import { isType } from '@sorare/core/src/lib/gql';

type Story = { __typename: any };
export const useRivalsStories = <T extends Story>(unreadStories?: T[]) => {
  return (unreadStories || []).reduce<{
    promotionRelegation: T | null;
    squadPromotionRelegation: T | null;
    aggregatedArena: T | null;
  }>(
    (obj, current) => {
      if (
        !obj.promotionRelegation &&
        isType(current, 'FootballRivalsPromotionRelegationStory')
      ) {
        obj.promotionRelegation = current;
      }
      if (
        !obj.squadPromotionRelegation &&
        isType(current, 'FootballRivalsSquadPromotionRelegationStory')
      ) {
        obj.squadPromotionRelegation = current;
      }
      if (
        !obj.aggregatedArena &&
        isType(current, 'FootballRivalsAggregatedArenaStory')
      ) {
        obj.aggregatedArena = current;
      }
      return obj;
    },
    {
      promotionRelegation: null,
      squadPromotionRelegation: null,
      aggregatedArena: null,
    }
  );
};
